import { FC, PropsWithChildren, ReactNode } from 'react'

export interface PdSectionProps {
  title: string
  titleClassName?: string
  titleAside?: ReactNode | string
  subtitle?: string
  bgWhite?: boolean
  bottomNoPadding?: boolean
  topNoPadding?: boolean
  className?: string
}

const PdSection: FC<PropsWithChildren<PdSectionProps>> = ({
  title,
  titleClassName,
  titleAside,
  subtitle,
  children,
  bgWhite,
  bottomNoPadding,
  topNoPadding,
  className,
}) => {
  const noSubtitle = !subtitle

  return (
    <div
      className={[
        bgWhite ? 'bg-white' : 'bg-pdbg',
        bottomNoPadding ? 'pb-0' : 'pb-15 laptop:pb-40',
        topNoPadding ? 'pt-0' : 'pt-15 laptop:pt-40',
        'w-full flex flex-col laptop:items-center',
        className,
      ].join(' ')}
    >
      {!!title && (
        <h3
          className={[
            'w-full text-2xl px-6',
            'laptop:text-42 laptop:text-center',
            noSubtitle ? 'pb-8 laptop:pb-16' : '',
            'font-semibold',
            titleClassName,
          ].join(' ')}
        >
          {title}
          {titleAside}
        </h3>
      )}

      {subtitle && (
        <p
          className={[' text-pd-gray px-6 pt-4 pb-8 laptop:pt-6 laptop:pb-16 laptop:text-center laptop:max-w-300'].join(
            ' '
          )}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        ></p>
      )}

      {children}
    </div>
  )
}

export default PdSection
